<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-header" style="padding: 0px !important">
                <div class="page-breadcrumb">
                    <div class="row">
                        <div class="col-5 align-self-center">
                            <h4 class="page-title">{{ $t("lang.label_rcat") }}</h4>
                        </div>
                        <div class="col-7 align-self-center">
                            <div class="d-flex align-items-right justify-content-end">
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item">
                                            <router-link
                                                :to="{ name: 'Setup' }"
                                                class="btn btn-info btn-sm mr-2"
                                            >
                                                <i class="fas fa-arrow-left"></i>
                                                {{ $t("lang.label_back") }}
                                            </router-link>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-6"></div>
                            <div class="col-md-6">
                                <input
                                    type="text"
                                    v-model="search"
                                    class="form-control search"
                                />
                            </div>
                        </div>
                        <br />
                        <table class="table table-striped table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>{{ $t("lang.label_g") }}</th>
                                    <th>{{ $t("lang.label_nc") }}</th>
                                    <th>{{ $t("lang.label_foods") }}</th>
                                    <th>{{ $t("lang.label_date") }}</th>
                                    <th>{{ $t("lang.label_restore") }}?</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody v-if="isLoading === true">
                                <tr>
                                    <td colspan="10">
                                        <Loader v-if="isLoading"></Loader>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(i, index) in filterItems" :key="index">
                                    <td style="width: 5%">
                                        {{ i.nameGroup }}
                                    </td>
                                    <td style="width: 6%">
                                        {{ i.name }}
                                    </td>
                                    <td style="width: 28%">
                                        <span
                                            class="badge badge-light"
                                            v-for="(k, ind) in i.foods"
                                            :key="ind"
                                            style="
                                                margin-right: 2px;
                                                margin-bottom: 2px;
                                                padding: 2px 4px;
                                                font-size: 10px;
                                                border: 1px solid #ccc;
                                                background-color: #fff;
                                            "
                                        >
                                            {{ k.name }}
                                        </span>
                                    </td>
                                    <td style="width: 17%">
                                        {{ i.fechaelim }}
                                    </td>
                                    <td style="width: 2%">
                                        <button
                                            type="submit"
                                            class="btn btn-warning"
                                            @click="restoreCat(i)"
                                        >
                                            <i class="fas fa-share fa-ms"></i>
                                        </button>
                                    </td>
                                    <td style="width: 5%">
                                        <button
                                            type="submit"
                                            class="btn btn-danger"
                                            @click="removeCat(i)"
                                        >
                                            <i class="fas fa-trash fa-ms"></i>
                                        </button>
                                    </td>
                                </tr>
                                <tr v-if="mGroup.length === 0">
                                    <td colspan="10">{{ $t("lang.label_nrecord") }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader.vue";
import axios from "axios";
export default {
    name: "MenuRestore",
    components: {
        Loader,
    },
    data () {
        return {
            isLoading: false,
            mGroup: [],
            search: "",
            f: {
                user_id: window.localAccountID,
                org_id: window.localorgdata,
            },
        };
    },
    created () {
        this.getRestore();
    },
    methods: {
        getRestore() {
            this.isLoading = true;
            window.master
                .post("/menu/category/getrestore", this.f)
                .then((response) => {
                    this.mGroup = response.data.result;
                    console.log(this.mGroup);
                    this.isLoading = false;
                })
                .catch((error) => {
                    this.isLoading = false;
                    console.log(error);
                });
        },
        removeCat(i) {
            this.$swal({
                title: window.lang2.msj_del_ctgory_specific,
                text: window.lang2.msj_you_sure + "?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: window.lang2.msj_del_it,
            }).then((result) => {
                if (result.value) {
                    window.master
                        .delete(
                            "menu/category/delete/" + i.id + "/" + window.localuserdata,
                            {
                                data: i,
                                org_id: window.localuserdata,
                                user_id: window.master_client,
                            }
                        )
                        .then((response) => {
                            this.getRestore();
                        })
                        .catch((error) => console.log(error));
                }
            });
        },
        restoreCat(i) {
            this.$swal({
                title: window.lang2.label_rt_cat + "?",
                text: window.lang2.msj_you_sure + "?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: window.lang2.label_yrestore + "!",
            }).then((result) => {
                if (result.value) {
                    window.master
                        .post("/menu/category/restorecategory", {
                            id: i.id,
                            org_id: window.localuserdata,
                            user_id: window.master_client,
                        })
                        .then((response) => {
                            console.log(response);
                            this.getRestore();
                        })
                        .catch((error) => console.log(error));
                }
            });
        },
    },
    computed: {
        filterItems: function () {
            var self = this;
            if (this.search !== "") {
                return this.mGroup.filter(function (item) {
                    if (item.name && item.name.indexOf(self.search.toLowerCase()) >= 0) {
                        return item;
                    }
                });
            } else {
                return this.mGroup.filter(function (item) {
                    if (item.name && item.name.indexOf(self.search.toLowerCase()) >= 0) {
                        return item;
                    }
                });
            }
        },
    },
};
</script>
<style scoped>
.search {
    border-color: #555;
}
</style>
